const { find } = require('lodash');

class CartItemMessageController {
    constructor(cartItemMessageService) {
        this.cartItemMessageService = cartItemMessageService;
    }

    $onChanges() {
        this.itemMessages = this.cartItemMessageService.buildItemMessages(this.trolleyItem, this.error);

        this.inlineMessage = this.nextMessage(this.itemMessages);
    }

    onDismiss(itemMessages, inlineMessage) {
        this.dismissMessage(itemMessages, inlineMessage);

        this.inlineMessage = this.nextMessage(itemMessages);
    }

    dismissMessage(itemMessages, inlineMessage) {
        inlineMessage.isDismissed = true;

        if (inlineMessage === itemMessages.errorMessage) {
            this.onDismissError();
        }
    }

    nextMessage(itemMessages) {
        return find([
            itemMessages.errorMessage,
            itemMessages.matchedPromotionMessage,
            itemMessages.missedPromotionMessage,
        ], message => message && !message.isDismissed);
    }
}

const cartItemMessageComponentDefinition = {
    bindings: {
        trolleyItem: '<',
        error: '<',
        onDismissError: '&',
    },
    controller: ['CartItemMessageService', CartItemMessageController],
    template: require('./cart-item-message.component.html').trim(),
};

module.exports = {
    CartItemMessageController,
    cartItemMessageComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-item-message.component.js